/*
 * FROM https://github.com/react-bootstrap/react-overlays/blob/master/src/utils/ownerDocument.js
 */
import ReactDOM from 'react-dom';
import ownerDocument from 'dom-helpers/ownerDocument';
export default function (componentOrElement) {
    return componentOrElement && ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}
